<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="保险公司">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-model="queryParam.companyNumber"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-form-item label="期数">
              <a-input placeholder.trim="请录入期数" v-model="queryParam.phase"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item label="保单号" >
              <a-input v-model.trim="queryParam.policy" placeholder="请输入保单号"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="10">
              <a-form-item label="导入日期">
                <a-range-picker
                  style="width: 200px"
                  v-model="queryParam.inputDateRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onDateChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="6">
              <a-form-item label="数据状态">
                <a-select placeholder.trim="请选择状态" v-model="queryParam.status">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="0">未匹配</a-select-option>
                  <a-select-option value="1">已匹配</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="6">
              <a-form-item label="佣金">
                <a-input placeholder.trim="请录入佣金" v-model="queryParam.brokerage"/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="10">
              <a-form-item label="项目名称">
                <j-dict-select-tag type="list" v-model="queryParam.project" dictCode="bms_project" placeholder="请选择项目"/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="10">
              <a-form-item label="部门"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-dict-select-tag
                  placeholder="请选择部门"
                  v-model="queryParam.sysOrgCode"
                  dictCode="sys_depart,depart_name,org_code">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="6" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
              {{ toggleSearchStatus ? '收起' : '展开' }}
              <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
            </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'insuranceData:add'">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('保司数据表')" v-has="'insuranceData:export'">导出</a-button>
      <a-button type="primary" icon="import" @click="handleImport" v-has="'insuranceData:import'">导入</a-button>
      <!--<a-dropdown v-if="selectedRowKeys.length > 0" v-has="'insuranceData:del'">-->
        <!--<a-menu slot="overlay" >-->
          <!--<a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>-->
        <!--</a-menu>-->
        <!--<a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>-->
      <!--</a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        <span style="float:right; ">金额单位：元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider v-if="record.status == '0'" type="vertical" v-has="'insuranceData:edit'"/>
          <a v-if="record.status == '0'" @click="handleEdit(record)" v-has="'insuranceData:edit'">编辑</a>
          <a-divider v-if="record.status == '0'" type="vertical" v-has="'insuranceData:del'"/>
          <a-popconfirm v-if="record.status == '0'" title="确定删除吗?" @confirm="() => handleDelete(record.id)" v-has="'insuranceData:del'">
            <a >删除</a>
          </a-popconfirm>
          <a-divider v-if="record.status == '1'" type="vertical" />
          <a v-if="record.status == '1'" @click="handleInvoiceInfo(record)">发票</a> <!--v-has="'insuranceData:invoice'"-->
        </span>

      </a-table>
    </div>

    <biz-insurance-data-modal ref="modalForm" @ok="modalFormOk"></biz-insurance-data-modal>
    <biz-insurance-data-import-modal ref="importModal" @ok="importModalOk"></biz-insurance-data-import-modal>
    <a-modal ref="invoiceModal" v-if="invoiceModalVisible" :visible.sync="invoiceModalVisible" title="发票信息" @ok="handleOk" @cancel="handleCancel">
      <biz-insurance-data-invoice-form :insuranceDataId="insuranceDataId">
      </biz-insurance-data-invoice-form>
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util';
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BizInsuranceDataModal from './modules/BizInsuranceDataModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import BizInsuranceDataImportModal from './modules/BizInsuranceDataImportModal'
  import BizInsuranceDataInvoiceForm from './modules/BizInsuranceDataInvoiceForm'
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import { getAction} from '@/api/manage'

  export default {
    name: 'BizInsuranceDataList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      BizInsuranceDataImportModal,
      BizInsuranceDataModal,
      JSearchSelectTag,
      BizInsuranceDataInvoiceForm
    },
    data () {
      return {
        disableMixinCreated: true,
        description: '保司数据表管理页面',
        invoiceModalVisible: false,
        insuranceDataId:'', // 当前选择的id
        queryParam:{
          companyNumber:'',
          phase:'',
          policy:''
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'日期',
            align:"center",
            dataIndex: 'date',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'状态',
            align:"center",
            dataIndex: "status",
            customRender:function (status) {
              if(status === '0'){
                return '未匹配'
              } else if(status === '1'){
                return '已匹配'
              } else {
                return ""
              }
            }
          },
          {
            title:'保险公司',
            className:'column-text',
            dataIndex: 'companyNumberDictText', //jeecg框架原字段名：companyNumber_dictText
            sorter: true
          },
          {
            title:'保单号',
            className:'column-text',
            dataIndex: 'policy',
            sorter: true
          },
          {
            title:'期数',
            align:"center",
            dataIndex: 'phase'
          },
          {
            title:'佣金比例',
            className:'column-money',
            dataIndex: 'brokerageRatio',
            customRender:function (text) {
              return !text ? '' : text + '%'
            }
          },
          {
            title:'佣金',
            className:'column-money',
            dataIndex: 'brokerage',
            customRender:function (text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title:'项目',
            align:"center",
            dataIndex: 'projectDictText'
          },
          {
            title:'新增/导入日期',
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:130,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/bms/bizInsuranceData/list",
          list2: "/bms/bizInsuranceData/list2",
          delete: "/bms/bizInsuranceData/delete",
          deleteBatch: "/bms/bizInsuranceData/deleteBatch",
          exportXlsUrl: "/bms/bizInsuranceData/exportXls",
          importExcelUrl: "bms/bizInsuranceData/importExcel",
        },
        dictOptions:{},
      }
    },
    created() {
      // this.loadData(1);
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      importModalOk(){
        this.loadData(1);
      },
      handleImport(){
        this.$refs.importModal.show();
      },
      getQueryParams() {
        var param = Object.assign({}, this.queryParam, this.isorter ,this.filters)
        if(param.policy){
          param.policy = `*${param.policy}*` // 保单号模糊匹配
        }
        let dateRange = param.inputDateRange;
        if(dateRange != null && dateRange != undefined && dateRange.length == 2){
          param.createTimeBegin = this.queryParam.inputDateRange[0] + ' 00:00:00';
          param.createTimeEnd = this.queryParam.inputDateRange[1] + ' 23:59:59';
          delete param.inputDateRange;
        }

        param.field = this.getQueryField()
        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param);
      },

      //加载数据
      loadData(arg) {
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list2, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
            this.afterLoadData(this.dataSource);
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      // 日期选择
      onDateChange: function (value, dateString) {
        this.queryParam.inputDateRange = dateString;
      },

      handleInvoiceInfo(record){
        this.insuranceDataId = record.id
        this.invoiceModalVisible = true
      },
      handleCancel(){
        this.$nextTick(()=> {
          this.invoiceModalVisible = false
        })
      },
      handleOk(){
        this.$nextTick(()=> {
          this.invoiceModalVisible = false
        })
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>